'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SnackbarItem = require('./SnackbarItem');
var _SnackbarItem2 = _interopRequireDefault(_SnackbarItem);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = _SnackbarItem2.default;